import { SxProps } from "@mui/material";

export const HeaderStyle: SxProps = {
  bgcolor: "background.paper",
  p: 3,
  height: "80px",
  width: "100%",
  borderBottom: "1px solid",
  borderColor: "divider",
};

export const CategorySelectorStyle: SxProps = {
  height: "60px",
  backgroundColor: "#ffffff",
  borderRadius: 0,
  fontSize: "22px",
  fontWeight: 600,
  "> fieldset": {
    border: "none",
  },
};

export const CategoryMenuStyle: SxProps = {
  ".MuiPaper-root": {
    boxShadow: "0px 0px 12px 0px rgba(0, 0, 0, 0.08)",
    ".MuiList-root": {
      ".MuiButtonBase-root": {
        padding: "12px 16px",
        fontSize: "14px",
        fontWeight: "regular",
        ":not(:last-child)": {
          borderBottom: "1px solid",
          borderColor: "divider",
        },
      },
    },
  },
};

export const PanelWrapper: SxProps = {
  backgroundColor: "#ffffff",
  width: "300px",
  borderRight: "1px solid",
  borderColor: "divider",
  height: "100%",
};

export const PanelItemsContainer: SxProps = {
  borderTop: "1px solid",
  borderColor: "divider",
  p: 2,
  height: "calc(100% - 80px)",
  overflowY: "hidden",

  ":hover": {
    overflowY: "auto",
  },
};

export const MenuItemStyle: SxProps = {
  borderRadius: "8px",
  border: "1px solid",
  p: 2,
  cursor: "pointer",
};

export const JournalAccordion: SxProps = {
  boxShadow: "none",
  border: "1px solid #E5E7EB",
  borderRadius: "8px !important",
  mb: 2.5,
  "::before": {
    backgroundColor: "transparent",
  },
};

export const JournalAccordionHeaderContainer: SxProps = {
  display: "flex",
  flex: 1,
  minWidth: "1px",
  alignItems: "center",
};

export const JournalAccordionHeader: SxProps = {
  py: 1.5,
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  flex: 1,
  minWidth: "1px",
};

const logStatusContainer = {
  border: 1,
  height: "50px",
  width: "fitContent",
  display: "flex",
  alignItems: "center",
  borderRadius: "8px",
  padding: "15px 20px",
  mr: 1,
  fontWeight: "600",
  fontSize: "16px",
};

export const loggedContainer: SxProps = {
  ...logStatusContainer,
  borderColor: "primary.main",
  color: "primary.main",
};

export const notloggedContainer: SxProps = {
  ...logStatusContainer,
  borderColor: "#FF8A4C",
  color: "#FF8A4C",
};
